import { createBrowserRouter, Navigate } from 'react-router-dom'
import { RootLayout } from '@/layouts/RootLayout'
import { DashboardLayout } from '@/layouts/DashboardLayout'
import { ProtectedRoute } from './ProtectedRoute'
import { AdminRoute } from './AdminRoute'
import { LoginPage } from '@/pages/LoginPage'
import { DomainsPage } from '@/pages/DomainsPage'
import { DomainDetailPage } from '@/pages/DomainDetailPage'
import { VerifyDomainPage } from '@/pages/VerifyDomainPage'
import { BulkJobDetailPage } from '@/pages/BulkJobDetailPage'
import { UsersPage } from '@/pages/UsersPage'
import { ProfilePage } from '@/pages/ProfilePage'
import { SettingsPage } from '@/pages/SettingsPage'
import { NotFoundPage } from '@/pages/NotFoundPage'

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: '/',
        element: <Navigate to="/login" replace />,
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/dashboard',
        element: (
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard/domains" replace />,
          },
          {
            path: 'domains',
            element: <DomainsPage />,
          },
          {
            path: 'domains/verify',
            element: <VerifyDomainPage />,
          },
          {
            path: 'domains/verify/jobs/:jobId',
            element: <BulkJobDetailPage />,
          },
          {
            path: 'domains/:domain',
            element: <DomainDetailPage />,
          },
          {
            path: 'users',
            element: (
              <AdminRoute>
                <UsersPage />
              </AdminRoute>
            ),
          },
          {
            path: 'profile',
            element: <ProfilePage />,
          },
          {
            path: 'settings',
            element: <SettingsPage />,
          },
          {
            path: '*',
            element: <NotFoundPage />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])
